<template>
  <div class="restbooktimeset" :style="{gridTemplateColumns: (info.storeType==='restaurant' || info.storeType==='event') ? '770px 1fr' : '1200px 1fr'}">
    <div :style="{position: 'relative'}" v-if="info.storeType==='restaurant'">
      <div class="switchs">
        <div>線上訂位設定</div>
        <div>
          <div label="僅先訂位"><input type="checkbox" :checked="info.bookOnly"  @change="$emit('update', { 'bookOnly': $event.target.checked })"></div>
        </div>
      </div>
      <div class="switchs">
        <div>即時點餐設定</div>
        <div>
          <div label="即時點餐"><input type="checkbox" :checked="info.immediate"  @change="$emit('update', { 'immediate': $event.target.checked })"></div>
          <div label="人數必填"><input type="checkbox" :checked="info.reserveNumRequired"  @change="$emit('update', { 'reserveNumRequired': $event.target.checked })"></div>
        </div>
      </div>
      <div class="switchs">
        <div>服務費</div>
        <div>
          <div label="內用" class="min" after="%"><input type="text" :value="(info.service?.instore || 0)"  @change="$emit('update', { service: { instore: $event.target.value, takeout: (info.service?.takeout || 0) } })"></div>
          <div label="外帶" class="min" after="%"><input type="text" :value="(info.service?.takeout || 0)"  @change="$emit('update', { service: { instore: (info.service?.instore || 0), takeout: $event.target.value } })"></div>
        </div>
      </div>
      <div class="switchs">
        <div>等候時間</div>
        <div>
          <div label="內用" class="min" after="分鐘"><input type="text" :value="info.delayInstore"  @change="$emit('update', { 'delayInstore': $event.target.value })"></div>
          <div label="外帶" class="min" after="分鐘"><input type="text" :value="info.delayTakeout"  @change="$emit('update', { 'delayTakeout': $event.target.value })"></div>
        </div>
      </div>
      <div class="switchs">
        <div>外帶自取</div>
        <div>
          <div label="平日"><input type="checkbox" :checked="info.restTakeout"  @change="$emit('update', { 'restTakeout': $event.target.checked })"></div>
          <div label="假日"><input type="checkbox" :checked="info.restTakeoutHoliday"  @change="$emit('update', { 'restTakeoutHoliday': $event.target.checked })"></div>
        </div>
      </div>
    </div>
    <div :style="{position: 'relative'}" v-else-if="info.storeType==='event'">
      <div class="switchs">
        <div>預約設定</div>
        <div>
          <div label="人數必填"><input type="checkbox" :checked="info.reserveNumRequired"  @change="$emit('update', { 'reserveNumRequired': $event.target.checked })"></div>
        </div>
      </div>
      <div class="boxx" :style="{marginTop: '57px'}"></div>
      <div class="boxx" :style="{marginTop: '57px'}">
        <div>訂單數上限 <sqr40016Vue :style="{marginLeft: '1em'}" v-if="edit!=='BookLimitation'&&!info.BookLimitation?.enabled" :text="'關閉功能中'" :bg="'var(--highlight)'"/><EditBtn @click="editItem=JSON.parse(JSON.stringify(info.BookLimitation||{ sheet: 1, totalAmount: 2000, enabled: true }));edit='BookLimitation'" :style="{marginLeft: 'auto'}"/></div>
          <template v-if="edit==='BookLimitation'">
            <Radio :defaultValue="editItem.enabled ? '滿足已下任一條件將不可預約' : '關閉功能'" @input="editItem.enabled=$event==='滿足已下任一條件將不可預約'" :fontSize="'20px'" :options="['關閉功能', '滿足已下任一條件將不可預約']" :style="{flexDirection: 'column', alignItems: 'flex-start', marginTop: '31px'}"/>
            <div class="desc" :style="{marginLeft: '2em'}">
              單時段接滿<input type="text" :style="{marginInline: '.5em'}" v-model.number="editItem.sheet">單
            </div>
            <BtnsS @cancel="editItem=null;edit=null" @save="$emit('update', { BookLimitation: editItem });edit=null" :style="{marginTop: '45px'}"/>
        </template>
        <div :style="{display:'flex', gap: '1.5em'}" v-if="info.BookLimitation?.enabled">
          <div>
            <div class="desc">
              單時段接滿<span>{{info.BookLimitation.sheet}}</span><span></span>單
            </div>
          </div>
          <div class="desc">將不可預約。</div>
        </div>
      </div>
      <div class="boxx" :style="{marginTop: '57px'}">
        <div>預約日範圍設定 <EditBtn v-if="!edit||edit!=='bookingRange'" :style="{marginLeft: 'auto'}" @click="editItem={bookingStart: JSON.parse(JSON.stringify(info.bookingStart)), bookingEnd: JSON.parse(JSON.stringify(info.bookingEnd))};edit='bookingRange'"/></div>
        <template v-if="edit==='bookingRange'">
        <div class="desc">
          開放<span v-if="editItem.bookingStart.unit==='minutes'||editItem.bookingStart.unit==='hours'">當天</span>
          <input type="text" :style="{marginLeft: '.5em'}" v-model.number="editItem.bookingStart.value">
          <select :style="{color: 'var(--highlight)', marginLeft: '.5em', textAlignLast: 'center'}" v-model="editItem.bookingStart.unit">
            <option value="minutes">分鐘</option>
            <option value="hours">小時</option>
            <option value="days">天</option>
            <option value="weeks">週</option>
            <option value="months">月</option>
          </select>
          後到
          <input type="text" :style="{marginLeft: '.5em'}" v-model.number="editItem.bookingEnd.value">
          <select :style="{color: 'var(--highlight)', marginLeft: '.5em', textAlignLast: 'center'}" v-model="editItem.bookingEnd.unit">
            <option value="minutes">分鐘</option>
            <option value="hours">小時</option>
            <option value="days">天</option>
            <option value="weeks">週</option>
            <option value="months">月</option>
          </select>前預約。
        </div>
        <BtnsS @cancel="editItem=null;edit=null" @save="$emit('update', { ...editItem });edit=null" :style="{marginTop: '45px'}"/>
        </template>
        <div v-else class="desc">
          開放{{(info.bookingStart.unit==='minutes'||info.bookingStart.unit==='hours') ? '當天' : ''}}<span>{{info.bookingStart?.value}}</span>
          <span>{{
          info.bookingStart?.unit === 'minutes' ? '分鐘'
        : info.bookingStart?.unit === 'hours' ? '小時'
        : info.bookingStart?.unit === 'days' ? '天'
        : info.bookingStart?.unit === 'weeks' ? '週'
        : info.bookingStart?.unit === 'months' ? '月' : ''
       }}</span>後到<span>{{info.bookingEnd?.value}}</span><span>{{
          info.bookingEnd?.unit === 'minutes' ? '分鐘'
        : info.bookingEnd?.unit === 'hours' ? '小時'
        : info.bookingEnd?.unit === 'days' ? '天'
        : info.bookingEnd?.unit === 'weeks' ? '週'
        : info.bookingEnd?.unit === 'months' ? '月' : ''}}</span>前預約。
        </div>
      </div>
      <editCubeDate :style="{marginTop: '57px'}" title="分類" :defaultValue="info.eventTypes" @save="$emit('update', { eventTypes: $event })"/>
      <editCube :style="{marginTop:'57px'}" :title="'參數1'" :defaultValue="info.field2" @save="$emit('update', { field2: $event })"/>
      <editCube :style="{marginTop:'57px'}" :title="'參數2'" :defaultValue="info.field3" @save="$emit('update', { field3: $event })"/>
    </div>
    <div>
      <div class="boxx">
        <div>預約訂位人數上限 <sqr40016Vue v-if="edit!=='restBookLimitation'&&!info.restBookLimitation.enabled" :style="{marginLeft: '1em'}" :text="'關閉功能中'" :bg="'var(--highlight)'"/>
          <EditBtn v-if="edit!=='restBookLimitation'" @click="editItem=JSON.parse(JSON.stringify(info.restBookLimitation));edit='restBookLimitation'" :style="{marginLeft: 'auto'}"/></div>
        <template v-if="edit==='restBookLimitation'">
          <Radio :defaultValue="editItem.enabled ? '單時段預約訂位總人數上限' : '關閉功能'" @input="editItem.enabled=$event==='單時段預約訂位總人數上限'" :fontSize="'20px'" :options="['關閉功能', '單時段預約訂位總人數上限']" :style="{flexDirection: 'column', alignItems: 'flex-start', marginTop: '31px'}"/>
          <div class="desc">
            大人<input type="text" :style="{marginInline: '.5em'}" v-model.number="editItem.num">
            位，小孩<input type="text" :style="{marginInline: '.5em'}" v-model.number="editItem.numChild">
            位
          </div>
          <div :style="{display: 'flex', flexDirection: 'column', gap: '10px', alignItems:'flex-start'}">
            <div class="desc">當天訂位開放人數上限</div>
            <div :style="{width: '100%', border:'1px solid #CACACA', padding: '.5em 1em', borderRadius:'3px'}">
              <div class="desc" :style="{marginTop:0}">
                總人次上限<input type="text" :style="{marginInline: '.5em'}" v-model.number="editItem.current">位，人數額滿將不可預約
              </div>
            <div class="desc">
              單筆預約至多<input type="text" :style="{marginInline: '.5em'}" v-model.number="editItem.singleNum">位，
              小孩至多<input type="text" :style="{marginInline: '.5em'}" v-model.number="editItem.singleNumChild">位。
            </div>
            </div>
          </div>
          <BtnsS @cancel="editItem=null;edit=null" @save="$emit('update', { restBookLimitation: editItem });edit=null" :style="{marginTop: '45px'}"/>
        </template>
        <template v-if="info.restBookLimitation?.enabled&&edit!=='restBookLimitation'">
        <div class="desc">
          大人<span>{{info.restBookLimitation.num}}</span><span></span>
          位，小孩<span>{{info.restBookLimitation.numChild}}</span><span></span>
          位
        </div>
        <div class="desc">
          當天訂位開放人數上限<span>{{info.restBookLimitation.current}}</span><span></span>
          位，人數額滿將不可預約。
        </div>
        <div class="desc">
          單筆預約至多 <span :style="{width: '90px'}">{{info.restBookLimitation.singleNum}}</span><span></span> 位，
          小孩至多 <span :style="{width: '90px'}">{{info.restBookLimitation.singleNumChild}}</span><span></span> 位。
        </div>
        </template>
      </div>
      <div class="boxx" :style="{marginTop: '57px'}">
        <div>訂單數上限 <sqr40016Vue :style="{marginLeft: '1em'}" v-if="edit!=='BookLimitation'&&!info.BookLimitation?.enabled" :text="'關閉功能中'" :bg="'var(--highlight)'"/><EditBtn @click="editItem=JSON.parse(JSON.stringify(info.BookLimitation||{ sheet: 1, totalAmount: 2000, enabled: true }));edit='BookLimitation'" :style="{marginLeft: 'auto'}"/></div>
          <template v-if="edit==='BookLimitation'">
            <Radio :defaultValue="editItem.enabled ? '滿足已下任一條件將不可預約' : '關閉功能'" @input="editItem.enabled=$event==='滿足已下任一條件將不可預約'" :fontSize="'20px'" :options="['關閉功能', '滿足已下任一條件將不可預約']" :style="{flexDirection: 'column', alignItems: 'flex-start', marginTop: '31px'}"/>
            <div class="desc" :style="{marginLeft: '2em'}">
              單時段接滿<input type="text" :style="{marginInline: '.5em'}" v-model.number="editItem.sheet">單
            </div>
            <div class="desc" :style="{marginLeft: '2em'}">
              訂單金額滿<input type="text" :style="{marginInline: '.5em'}" v-model.number="editItem.totalAmount">元
            </div>
            <BtnsS @cancel="editItem=null;edit=null" @save="$emit('update', { BookLimitation: editItem });edit=null" :style="{marginTop: '45px'}"/>
        </template>
        <div :style="{display:'flex', gap: '1.5em'}" v-if="info.BookLimitation?.enabled">
          <div>
            <div class="desc">
              單時段接滿<span>{{info.BookLimitation.sheet}}</span><span></span>單
            </div>
            <div class="desc">
              訂單金額滿<span>{{info.BookLimitation.totalAmount}}</span><span></span>元
            </div>
          </div>
          <div class="desc">將不可預約。</div>
        </div>
      </div>
      <div class="boxx" :style="{marginTop: '57px'}">
        <div>預約日範圍設定 <EditBtn v-if="!edit||edit!=='bookingRange'" :style="{marginLeft: 'auto'}" @click="editItem={
          bookingStart: JSON.parse(JSON.stringify(info.bookingStart)),
          bookingEnd: JSON.parse(JSON.stringify(info.bookingEnd)),
          bookingStartTable: JSON.parse(JSON.stringify(info.bookingStartTable)),
          bookingEndTable: JSON.parse(JSON.stringify(info.bookingEndTable))
        };edit='bookingRange'"/></div>
        <template v-if="edit==='bookingRange'">
        <div class="desc">
          桌菜: 開放<span v-if="editItem.bookingStartTable.unit==='minutes'||editItem.bookingStartTable.unit==='hours'">當天</span>
          <input type="text" :style="{marginLeft: '.5em'}" v-model.number="editItem.bookingStartTable.value">
          <select :style="{color: 'var(--highlight)', marginLeft: '.5em', textAlignLast: 'center'}" v-model="editItem.bookingStartTable.unit">
            <option value="minutes">分鐘</option>
            <option value="hours">小時</option>
            <option value="days">天</option>
            <option value="weeks">週</option>
            <option value="months">月</option>
          </select>
          後到
          <input type="text" :style="{marginLeft: '.5em'}" v-model.number="editItem.bookingEndTable.value">
          <select :style="{color: 'var(--highlight)', marginLeft: '.5em', textAlignLast: 'center'}" v-model="editItem.bookingEndTable.unit">
            <option value="minutes">分鐘</option>
            <option value="hours">小時</option>
            <option value="days">天</option>
            <option value="weeks">週</option>
            <option value="months">月</option>
          </select>前預約。
        </div>
        <div class="desc">
          套餐: 開放<span v-if="editItem.bookingStart.unit==='minutes'||editItem.bookingStart.unit==='hours'">當天</span>
          <input type="text" :style="{marginLeft: '.5em'}" v-model.number="editItem.bookingStart.value">
          <select :style="{color: 'var(--highlight)', marginLeft: '.5em', textAlignLast: 'center'}" v-model="editItem.bookingStart.unit">
            <option value="minutes">分鐘</option>
            <option value="hours">小時</option>
            <option value="days">天</option>
            <option value="weeks">週</option>
            <option value="months">月</option>
          </select>
          後到
          <input type="text" :style="{marginLeft: '.5em'}" v-model.number="editItem.bookingEnd.value">
          <select :style="{color: 'var(--highlight)', marginLeft: '.5em', textAlignLast: 'center'}" v-model="editItem.bookingEnd.unit">
            <option value="minutes">分鐘</option>
            <option value="hours">小時</option>
            <option value="days">天</option>
            <option value="weeks">週</option>
            <option value="months">月</option>
          </select>前預約。
        </div>
        <BtnsS @cancel="editItem=null;edit=null" @save="$emit('update', { ...editItem });edit=null" :style="{marginTop: '45px'}"/>
        </template>
        <template  v-else>
        <div class="desc">
          桌菜: 開放{{(info.bookingStartTable.unit==='minutes'||info.bookingStartTable.unit==='hours') ? '當天' : ''}}<span>{{info.bookingStartTable?.value}}</span><span>{{
          info.bookingStartTable?.unit === 'minutes' ? '分鐘'
        : info.bookingStartTable?.unit === 'hours' ? '小時'
        : info.bookingStartTable?.unit === 'days' ? '天'
        : info.bookingStartTable?.unit === 'weeks' ? '週'
        : info.bookingStartTable?.unit === 'months' ? '月' : ''
       }}</span>後到<span>{{info.bookingEndTable?.value}}</span><span>{{
          info.bookingEndTable?.unit === 'minutes' ? '分鐘'
        : info.bookingEndTable?.unit === 'hours' ? '小時'
        : info.bookingEndTable?.unit === 'days' ? '天'
        : info.bookingEndTable?.unit === 'weeks' ? '週'
        : info.bookingEndTable?.unit === 'months' ? '月' : ''}}</span>前預約。
        </div>
        <div class="desc">
          套餐: 開放{{(info.bookingStart.unit==='minutes'||info.bookingStart.unit==='hours') ? '當天' : ''}}<span>{{info.bookingStart?.value}}</span><span>{{
          info.bookingStart?.unit === 'minutes' ? '分鐘'
        : info.bookingStart?.unit === 'hours' ? '小時'
        : info.bookingStart?.unit === 'days' ? '天'
        : info.bookingStart?.unit === 'weeks' ? '週'
        : info.bookingStart?.unit === 'months' ? '月' : ''
       }}</span>後到<span>{{info.bookingEnd?.value}}</span><span>{{
          info.bookingEnd?.unit === 'minutes' ? '分鐘'
        : info.bookingEnd?.unit === 'hours' ? '小時'
        : info.bookingEnd?.unit === 'days' ? '天'
        : info.bookingEnd?.unit === 'weeks' ? '週'
        : info.bookingEnd?.unit === 'months' ? '月' : ''}}</span>前預約。
        </div>
        </template>
      </div>
      <div class="boxx" :style="{marginTop: '57px'}">
        <div>取消期限設定 <EditBtn v-if="!edit||edit!=='cancelBefore'" :style="{marginLeft: 'auto'}"
          @click="editItem={ cancelBefore: JSON.parse(JSON.stringify(info?.cancelBefore || { unit: 'minutes', value: 30 }))};edit='cancelBefore'"/></div>
        <template v-if="edit==='cancelBefore'">
        <div class="desc">
          請在{{(editItem.cancelBefore.unit==='minutes'||editItem.cancelBefore.unit==='hours') ? '當天' : ''}}
          <input type="text" :style="{marginLeft: '.5em'}" v-model.number="editItem.cancelBefore.value">
          <select :style="{color: 'var(--highlight)', marginLeft: '.5em', textAlignLast: 'center'}" v-model="editItem.cancelBefore.unit">
            <option value="minutes">分鐘</option>
            <option value="hours">小時</option>
            <option value="days">天</option>
            <option value="weeks">週</option>
            <option value="months">月</option>
          </select>前取消。
        </div>
        <BtnsS @cancel="editItem=null;edit=null" @save="$emit('update', { ...editItem });edit=null" :style="{marginTop: '45px'}"/>
        </template>
        <div v-else class="desc">
          請在{{(info.cancelBefore?.unit==='minutes'||info.cancelBefore?.unit==='hours') ? '當天' : ''}}<span>{{info.cancelBefore?.value}}</span><span>{{
          info.cancelBefore?.unit === 'minutes' ? '分鐘'
        : info.cancelBefore?.unit === 'hours' ? '小時'
        : info.cancelBefore?.unit === 'days' ? '天'
        : info.cancelBefore?.unit === 'weeks' ? '週'
        : info.cancelBefore?.unit === 'months' ? '月' : ''
       }}</span>前取消。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import editCube from '../../components/editCubeV2Input.vue'
import editCubeDate from '../../components/editCube3info.vue'
import EditBtn from '../../components/btn/edit.vue'
import sqr40016Vue from '../../components/btn/sqr40016.vue'
import Radio from '../../components/radio/radio.vue'
export default {
  name: 'restBookSummarySet',
  props: ['info'],
  components: {
    editCubeDate,
    EditBtn,
    sqr40016Vue,
    Radio,
    editCube
  },
  data () {
    return {
      edit: null,
      restRatioHoliday: 0,
      restRatioWeekday: 0,
      editItem: null,
      wdy: ['日', '一', '二', '三', '四', '五', '六']
    }
  },
  watch: {
  },
  computed: {
  },
  async mounted () {
  }

}
</script>

<style lang="scss" scoped>
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #FF8B8B;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
.editBtn {
  margin-left: auto;
  width: 35px;
  height: 35px;
  background-color: var(--color-pri);
  background-image: url(./pen.svg);
  background-position: center;
  background-repeat: no-repeat;
  border: none;
  border-radius: 50%;
  background-size: 19px;
}
.attendance {
  height: 50px;
  display: block;
  font-weight: 400;
  font-size: 25px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  font-family: 'Roboto';
  &>div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 80px;
  }
  &>div>div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    &::after {
      content: '%';
    }
  }
  input {
    width: 100px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    font-family: Roboto;
    letter-spacing: 2px;
    color: #FF8B8B;
      }
}
.switchs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
  margin-bottom: 15px;
  &>div:nth-child(2) {
    display: flex;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    width: 100%;
    height: 65px;
    align-items: center;
    justify-content: flex-start;
    margin-block: 10px 30px;
    &>div {
      width: 220px;
      height: 65px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-inline: 14px;
      border: 2px dashed var(--color-pri);
      border-radius: 5px;
      &::before {
        content: attr(label);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
      }
      &.min {
        width: 260px;
      }
      &.min::after{
        content: attr(after);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
        align-self: x;
      }
    }
    input[type=text] {
      height: 40px;
      width: 100px;
      border: 1px solid #C4C4C4;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      font-family: Roboto;
      letter-spacing: 2px;
      color: #FF8B8B;
    }
    input[type=checkbox] {
      appearance: none;
      width: 39px;
      height: 20px;
      border-radius: 10px;
      position: relative;
        background-color: #FF8B8B;
      &:checked {
        background-color: #85CA9E;
      }
      &::before {
        content: '';
        display: inline-flex;
        width: 16px;
        height: 16px;
        position: absolute;
        left: 2px;
        right: auto;
        top: 2px;
        background-color: #FFFFFF;
        border-radius: 8px;
      }
      &:checked::before {
        right: 2px;
        left: auto;
      }
      &.invert {
        background-color: #85CA9E;
        &:checked {
          background-color: #FF8B8B;
        }
      }
    }
  }
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;

  }
}
.boxx {
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;
  }
}
.restbooktimeset {
  display: grid;
  &>div{
    &:nth-child(1) {
      padding: 25px 53px 25px 82px;
    }
    &:nth-child(2) {
      border-left: 1px solid var(--color-pri);
      padding: 25px 37px;
    }
    box-sizing: border-box;
    overflow-y: auto;
    height: calc(100vh - 90px);
  }
}

.desc {
  margin-top: 26px;
  color: var(--unnamed, #6D6D6D);
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 2px;
  gap: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: start;
  flex-wrap: wrap;
    input[type=text] {
      height: 40px;
      width: 100px;
      border: 1px solid #C4C4C4;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      font-family: Roboto;
      letter-spacing: 2px;
      color: #FF8B8B;
    }
    select {
      height: 40px;
      border: 1px solid #C4C4C4;
      border-radius: 3px;
      margin-right: 3px;
    }
  span {
    color: var(--unnamed, #FF8B8B);
    font-family: Noto Sans TC;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 30px */
    letter-spacing: 1px;
    margin-inline: .5em;
    &:nth-child(odd) {
      display: inline-flex;
      border: 1px solid #CACACA;
      width: 100px;
      height: 37px;
      align-items: center;
      justify-content: center;

    }
  }
}
</style>
